'use es6';

import Raven from 'raven-js';
export const reportMissingCategoryFeatureTranslation = (category, feature, extra = {}) => {
  Raven.captureMessage('Missing category feature translation', {
    level: 'error',
    extra: Object.assign({}, extra, {
      category,
      feature
    })
  });
};
export const reportZorseUndefined = (extra = {}) => {
  Raven.captureMessage('hubspot.zorse not defined', {
    level: 'warning',
    extra
  });
};